import SimpleModalContent from "./SimpleModalContent";
import styles from "./SimpleModalContent.module.scss";
import React from "react";
import {useCsContext} from "../../state/CsInstance";
import {observer} from "mobx-react-lite";
import ValidationForm from "../ValidationForm/ValidationForm";

/**
 * Modal displayed when adding a new actor:
 * ┌────────────────────────────────────────┐
 * │  Add Actor                             │
 * │  Create actor called <name>            │
 * │  ┌─────────────────────────────────┐   │
 * │  └─────────────────────────────────┘   │
 * │  <name> is an invalid class name       │
 * │  ┌─────────────┐     ┌─────────────┐   │
 * │  │    Cancel   │     │   Confirm   │   │
 * │  └─────────────┘     └─────────────┘   │
 * └────────────────────────────────────────┘
 */
const AddActorModalContent = () => {
	const {codeStore, globalModalStore} = useCsContext();

	const onClickSuccess = () => {
		if (!isValid) {
			// Shouldn't happen, but just in case
			globalModalStore.closeModal();
			return;
		}
		const javaCode = codeStore.addActorClass(newClass);
		codeStore.codeMirrorStore.updateEditorContent(javaCode);
		codeStore.hasUncompiledChanges = true;
		globalModalStore.closeModal();
	};

	const onClickCancel = () => {
		globalModalStore.closeModal();
	};

	const [newClass, setNewClass] = React.useState("");
	const [isValid, setIsValid] = React.useState(false);
	const [inputReceivedSinceOpening, setInputReceivedSinceOpening] =
		React.useState(false);

	const newClassDisplayText =
		inputReceivedSinceOpening && newClass ? newClass : "___";

	return (
		<SimpleModalContent
			onSuccess={onClickSuccess}
			onCancel={onClickCancel}
			disableSubmit={!isValid}
			title={"New Actor Subclass"}
		>
			<div className={styles.modalText}>
				public class{" "}
				<span className={styles.className}>{newClassDisplayText}</span> extends{" "}
				<span className={styles.className}>Actor</span>
			</div>

			<ValidationForm
				setNewClass={setNewClass}
				setValidationResult={setIsValid}
				onInputReceived={() => {
					setInputReceivedSinceOpening(true);
				}}
			/>
		</SimpleModalContent>
	);
};

export default observer(AddActorModalContent);
